import { VehicleOutput } from '@allocab/allocab-commons-shared-types';
import { ExternalManageDriverOnVehicleInput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const unassignDriverToVehicle = (input: ExternalManageDriverOnVehicleInput) =>
  driverApi.post<ExternalManageDriverOnVehicleInput, VehicleOutput>(`/v1/vehicle/unassign-driver`, input);

export const useUnassignDriverToVehicle = () =>
  useMutation<VehicleOutput, unknown, ExternalManageDriverOnVehicleInput>({
    mutationFn: unassignDriverToVehicle,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(queryKeys.user.fetchDriversForVehicle(variables.vehicleId));
    },
  });
